import * as React from 'react'

import { Box, CardInfo, Text } from '@factorialco/deprecated-design-system'
import sortBy from 'lodash/sortBy'

import createMemo from 'modules/core/hooks/createMemo'
import i18n from 'modules/core/lib/i18n'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import { isVisible } from 'modules/custom_resources/lib/utils'
import type CustomField from 'modules/custom_resources/store/models/customFields/Field'
import type Field from 'modules/custom_resources/store/models/customResources/Field'
import type Resource from 'modules/custom_resources/store/models/customResources/Resource'
import type Schema from 'modules/custom_resources/store/models/customResources/Schema'
import type Value from 'modules/custom_resources/store/models/customResources/Value'
import type Employee from 'modules/employees/store/models/Employee'

import List from './_List'

const useFilter = createMemo(
  (schemas: Schema[], fields: Field[], employee: Employee | null | undefined) =>
    schemas.filter(
      (schema) =>
        fields.filter(
          (f: Field | CustomField) =>
            f.get('schema_id') === schema.get('id') &&
            isVisible(employee, contractVersions)(f.attributes.visible)
        ).length
    )
)
interface Props {
  employee: Employee
  schemas: Schema[]
  fields: Field[]
  resources: Resource[]
  values: Value[]
  attachableId: number
  attachableType: string
  canManage: boolean
}

const CustomTablesList = ({
  employee,
  schemas,
  fields,
  resources,
  values,
  attachableId,
  attachableType,
  canManage,
}: Props) => {
  const refs = schemas.map(() => React.createRef<HTMLElement>())
  const filteredSchemas = useFilter(schemas, fields, employee)

  const sortedSchemas = sortBy(filteredSchemas, (schema) => schema.get('position'))

  const canAddValues = employee.policy.can('addCustomTablesRecords')

  return (
    <Box flexGrow flexDirection="column" paddingY="s32" paddingRight="s48">
      {sortedSchemas.length > 0 && (
        <List
          attachableId={attachableId}
          attachableType={attachableType}
          employee={employee}
          fields={fields}
          resources={resources}
          schemaRefs={refs}
          schemas={sortedSchemas}
          values={values}
          canManage={canManage}
          canAddValues={canAddValues}
        />
      )}
      {sortedSchemas.length === 0 && (
        <CardInfo>
          <Box flexDirection="row" justifyContent="center" flexGrow>
            <Text.Normal>{i18n.t('custom_tables.none')}</Text.Normal>
          </Box>
        </CardInfo>
      )}
    </Box>
  )
}

export default CustomTablesList
